module.exports = __webpack_public_path__ + "img/mind_skeleton_time_6.7ce04bcd.png";